/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import DataTable from "../../../components/DataTable";
import { useListAllDbSoftware } from "../../../api/softwareImages";
import { useSubmitDbPatchRequestDialog } from "../Dialogs/SubmitDbPatchRequestDialog";
import { useNavigate } from "react-router-dom";
import { CloudIcon } from "../Utils";
import styles from "../styles";

const DbSoftware = ({
  engine,
  releaseBranch,
  displayNotification,
  reloadToggle,
}) => {
  const navigate = useNavigate();

  const [dbSoftware, setDbSoftware] = useState([]);

  const { submitDbPatchRequestDialog, setOpenSubmitDbPatchRequestDialog } =
    useSubmitDbPatchRequestDialog(
      () => navigate(`/apps/tessell/software-images/db-software/builds`),
      displayNotification
    );

  const {
    postData: listAllDbSoftware,
    response: listAllDbSoftwareResp,
    isLoading: isLoadingDbSoftware,
  } = useListAllDbSoftware(engine, releaseBranch);

  useEffect(() => {
    listAllDbSoftware();
  }, [engine, releaseBranch, reloadToggle]);

  useEffect(() => {
    if (Array.isArray(listAllDbSoftwareResp?.dbSoftware)) {
      setDbSoftware(listAllDbSoftwareResp.dbSoftware);
    } else {
      setDbSoftware([]);
    }
  }, [listAllDbSoftwareResp]);

  const columns = [
    {
      field: "patchVersionName",
      renderHeader: () => "Name",
      flex: 2,
      cellClassName: "name-column--cell",
      renderCell: ({ row: { patchVersionName } }) => patchVersionName || "",
    },
    {
      field: "patchVersion",
      flex: 1,
      renderHeader: () => "Patch Version",
      renderCell: ({ row: { patchVersion } }) => patchVersion ?? "",
    },
    {
      field: "majorVersion",
      flex: 2,
      renderHeader: () => "Major Version",
      renderCell: ({ row: { majorVersion } }) => majorVersion ?? "",
    },
    {
      field: "osVersionName",
      flex: 1.25,
      renderHeader: () => "OS",
      renderCell: ({ row: { osVersionName } }) => osVersionName ?? "",
    },
    {
      field: "clouds",
      flex: 1.5,
      sortable: false,
      renderHeader: () => "Clouds",
      renderCell: ({ row: { clouds } }) => (
        <Box sx={styles.cloudsCellBox}>
          {Object.keys(clouds)?.map((item, i) => (
            <CloudIcon key={i} cloud={item} size="20px" />
          ))}
        </Box>
      ),
    },
    {
      field: "actions",
      type: "actions",
      width: 56,
      getActions: ({ row }) => [
        <GridActionsCellItem
          label="Submit Patch Request"
          onClick={() => {
            setOpenSubmitDbPatchRequestDialog(
              {
                engine: engine,
                releaseBranch: releaseBranch,
                majorVersion: row?.majorVersion,
                majorVersionName: row?.majorVersionName,
                oldPatchVersionName: row?.patchVersionName,
                oldPatchVersion: row?.patchVersion,
              },
              Object.keys(row?.clouds)
            );
          }}
          showInMenu
        />,
      ],
    },
  ];

  return (
    <>
      {submitDbPatchRequestDialog}
      <DataTable
        height="100%"
        sx={styles.viewTable}
        getRowId={(row) => row?.versionRefId}
        loading={isLoadingDbSoftware}
        rows={dbSoftware}
        columns={columns}
      />
    </>
  );
};

export default DbSoftware;
